import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { View } from 'foundations-components/components/View';
import { useMediaBySize } from 'pricing-pages-ui-components/hooks/useMedia';
import { MerchCardGridLayout } from 'pricing-pages-ui-components/layouts/merch-cards/MerchCardGridLayout';
import { useState } from 'react';
import { HsocMerchCard } from './merch-card-grid/HsocMerchCard';
import HsocTermToggle from './HsocTermToggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GRID_AREA_NAMES = ['Title', 'Subheading', 'Pricing', 'CTAs', 'Features', 'Footer'];
const HsocMerchCardGridLayout = _ref => {
  let {
      children
    } = _ref,
    gridProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMd = useMediaBySize('md');
  return /*#__PURE__*/_jsx(MerchCardGridLayout, Object.assign({
    gridAreaNames: GRID_AREA_NAMES,
    position: "relative",
    gridAutoColumns: isMd ? 'minmax(0, 1fr)' : '100%',
    columnGap: isMd ? '500' : '0',
    inlineSize: "100%",
    maxInlineSize: isMd ? '1200px' : '450px',
    marginInline: "auto"
  }, gridProps, {
    children: children
  }));
};
const HsocMerchCardGrid = ({
  cards,
  onTermChange
}) => {
  const [activeTerm, setActiveTerm] = useState('ANNUAL');
  const handleTermChange = term => {
    setActiveTerm(term);
    onTermChange === null || onTermChange === void 0 || onTermChange(term);
  };
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(HsocTermToggle, {
      activeTerm: activeTerm,
      onTermChange: handleTermChange
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(HsocMerchCardGridLayout, {
        children: cards.map((card, index) => /*#__PURE__*/_jsx(HsocMerchCard, Object.assign({}, card, {
          columnStart: index + 1
        }), index))
      })
    })]
  });
};
export default HsocMerchCardGrid;